import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchServices } from "../../Redux/WebsiteSlice";
import { useBookingModal } from "../../context/BookingModalContext";
import s1 from "../../assets/img/s1.jpg";
import s2 from "../../assets/img/s2.png";
import s3 from "../../assets/img/s3.png";
import s4 from "../../assets/img/s4.jpg";
import "./ServicesPage.scss";

const SERVICE_FALLBACKS = [s1, s2, s3, s4];

const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/uploads/")) {
    return "https://api-test.swifttoolskit.cloud/api" + url;
  }
  return url;
};

const ServicesPage = () => {
  const dispatch = useDispatch();
  const services = useSelector((state) => state.website.services);
  const { openModal } = useBookingModal();

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  return (
    <div className="page-services">
      <div className="page-hero">
        <div className="page-hero__content">
          <span className="small__text">WHAT WE OFFER</span>
          <h1 className="headline__text">
            Our <span>Services</span>
          </h1>
          <p className="page-hero__subtitle">
            Expert physiotherapy services tailored to help you recover, move better, and live pain-free.
          </p>
        </div>
      </div>

      {services && services.length > 0 && (
        <div className="services-grid-section">
          <div className="services-grid-section__inner">
            <div className="services-page-grid">
              {services.map((service, index) => (
                <div key={service._id} className="service-page-card">
                  <div className="service-page-card__image">
                    <img
                      src={service.image ? getImageUrl(service.image) : SERVICE_FALLBACKS[index % SERVICE_FALLBACKS.length]}
                      alt={service.title}
                      onError={(e) => {
                        e.target.src = SERVICE_FALLBACKS[index % SERVICE_FALLBACKS.length];
                      }}
                    />
                  </div>
                  <div className="service-page-card__content">
                    <h3 className="service-page-card__title">{service.title}</h3>
                    {service.description && (
                      <p className="service-page-card__desc">{service.description}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="services-cta">
        <div className="services-cta__inner">
          <span className="small__text">READY TO GET STARTED?</span>
          <h2>Book Your Physiotherapy Session</h2>
          <p>
            Our experienced physiotherapists will assess your condition and create a personalised treatment plan just for you.
          </p>
          <button
            type="button"
            onClick={() => setTimeout(openModal, 0)}
            className="site__button site__button_style--solid site__button_shape--default"
          >
            <span className="text">Book an Appointment</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
